/**
 * Internal: the polymorphic `as` tag map + shared props for the motion
 * wrappers. Restricting `as` to a known set of intrinsic tags keeps the
 * wrappers strictly typed without a generic-polymorphic-ref dance.
 */
import { motion } from "framer-motion";
import type { ReactNode } from "react";

export const MOTION_TAGS = {
  div: motion.div,
  section: motion.section,
  header: motion.header,
  h1: motion.h1,
  h2: motion.h2,
  h3: motion.h3,
  h4: motion.h4,
  footer: motion.footer,
  main: motion.main,
  nav: motion.nav,
  aside: motion.aside,
  article: motion.article,
  ul: motion.ul,
  ol: motion.ol,
  li: motion.li,
  form: motion.form,
  fieldset: motion.fieldset,
  span: motion.span,
  p: motion.p,
  a: motion.a,
  label: motion.label,
};

export type MotionTag = keyof typeof MOTION_TAGS;

export interface MotionWrapperProps {
  /** Intrinsic element to render. Default `'div'`. */
  as?: MotionTag;
  className?: string;
  children?: ReactNode;
  /** Forwarded verbatim so wrapping a tested element never moves its selector. */
  "data-testid"?: string;
}
